/* tslint:disable */
/* eslint-disable */
/**
 * mindd-stim3-home-api-server
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { Prescription } from '../model';
/**
 * MyPrescriptionControllerApi - axios parameter creator
 * @export
 */
export const MyPrescriptionControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 토큰의 patientId/orgId 에 속한 처방만 돌려줍니다. 없는 id·삭제된 처방·남의 처방은 모두 404 입니다 — 셋을 구분해 답하면 처방 id 존재 여부를 캐는 채널이 됩니다.
         * @summary 환자 본인의 처방 단건 조회
         * @param {string} prescriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findMyPrescriptionById: async (prescriptionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'prescriptionId' is not null or undefined
            assertParamExists('findMyPrescriptionById', 'prescriptionId', prescriptionId)
            const localVarPath = `/api/v1/me/prescriptions/{prescriptionId}`
                .replace(`{${"prescriptionId"}}`, encodeURIComponent(String(prescriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 환자 서버 토큰(STIM_HOME_PATIENT)의 patientId/orgId 에 해당하는 처방 리스트를 반환합니다.
         * @summary 환자 본인의 처방 목록 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findMyPrescriptions: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/me/prescriptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MyPrescriptionControllerApi - functional programming interface
 * @export
 */
export const MyPrescriptionControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MyPrescriptionControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 토큰의 patientId/orgId 에 속한 처방만 돌려줍니다. 없는 id·삭제된 처방·남의 처방은 모두 404 입니다 — 셋을 구분해 답하면 처방 id 존재 여부를 캐는 채널이 됩니다.
         * @summary 환자 본인의 처방 단건 조회
         * @param {string} prescriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findMyPrescriptionById(prescriptionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Prescription>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findMyPrescriptionById(prescriptionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MyPrescriptionControllerApi.findMyPrescriptionById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 환자 서버 토큰(STIM_HOME_PATIENT)의 patientId/orgId 에 해당하는 처방 리스트를 반환합니다.
         * @summary 환자 본인의 처방 목록 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findMyPrescriptions(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Prescription>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findMyPrescriptions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MyPrescriptionControllerApi.findMyPrescriptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MyPrescriptionControllerApi - factory interface
 * @export
 */
export const MyPrescriptionControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MyPrescriptionControllerApiFp(configuration)
    return {
        /**
         * 토큰의 patientId/orgId 에 속한 처방만 돌려줍니다. 없는 id·삭제된 처방·남의 처방은 모두 404 입니다 — 셋을 구분해 답하면 처방 id 존재 여부를 캐는 채널이 됩니다.
         * @summary 환자 본인의 처방 단건 조회
         * @param {string} prescriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findMyPrescriptionById(prescriptionId: string, options?: any): AxiosPromise<Prescription> {
            return localVarFp.findMyPrescriptionById(prescriptionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 환자 서버 토큰(STIM_HOME_PATIENT)의 patientId/orgId 에 해당하는 처방 리스트를 반환합니다.
         * @summary 환자 본인의 처방 목록 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findMyPrescriptions(options?: any): AxiosPromise<Array<Prescription>> {
            return localVarFp.findMyPrescriptions(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MyPrescriptionControllerApi - object-oriented interface
 * @export
 * @class MyPrescriptionControllerApi
 * @extends {BaseAPI}
 */
export class MyPrescriptionControllerApi extends BaseAPI {
    /**
     * 토큰의 patientId/orgId 에 속한 처방만 돌려줍니다. 없는 id·삭제된 처방·남의 처방은 모두 404 입니다 — 셋을 구분해 답하면 처방 id 존재 여부를 캐는 채널이 됩니다.
     * @summary 환자 본인의 처방 단건 조회
     * @param {string} prescriptionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyPrescriptionControllerApi
     */
    public findMyPrescriptionById(prescriptionId: string, options?: RawAxiosRequestConfig) {
        return MyPrescriptionControllerApiFp(this.configuration).findMyPrescriptionById(prescriptionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 환자 서버 토큰(STIM_HOME_PATIENT)의 patientId/orgId 에 해당하는 처방 리스트를 반환합니다.
     * @summary 환자 본인의 처방 목록 조회
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyPrescriptionControllerApi
     */
    public findMyPrescriptions(options?: RawAxiosRequestConfig) {
        return MyPrescriptionControllerApiFp(this.configuration).findMyPrescriptions(options).then((request) => request(this.axios, this.basePath));
    }
}

